import seo from '@/assets/data/seo.json';

export default {
  loader: undefined,

  pages: {
    ['amsterdam']: { },
    ['san-francisco']: { },
    ['new-york']: { },
  },

  seo,

  media: { },

  components: { },

  speakers: {
    ['amsterdam']: { },
    ['san-francisco']: { },
    ['new-york']: { },
  },
};
